import { render, staticRenderFns } from "./ProductPreviewCard.vue?vue&type=template&id=9e5598d0&scoped=true"
import script from "./ProductPreviewCard.vue?vue&type=script&lang=js"
export * from "./ProductPreviewCard.vue?vue&type=script&lang=js"
import style0 from "./ProductPreviewCard.vue?vue&type=style&index=0&id=9e5598d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5598d0",
  null
  
)

export default component.exports